"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITE = exports.TRUE_WHITE = exports.SCREENFREE_YELLOW = exports.SCREENFREE_RED = exports.SCREENFREE_PURPLE = exports.SCREENFREE_GREEN = exports.SCREENFREE_BLUE = exports.SAND_YELLOW_50 = exports.SAND_YELLOW_25 = exports.SAND_YELLOW = exports.RED = exports.PINK_LED = exports.PALE_WHITE = exports.PALE_BLUE = exports.MAIN_BLUE = exports.INDICATOR_WHITE = exports.INDICATOR_RED = exports.INDICATOR_ORANGE = exports.INDICATOR_GREEN = exports.HINT_GREY = exports.GREY_4 = exports.GREY_3 = exports.GREY_2 = exports.GREY = exports.GREEN_LED = exports.GREEN = exports.DASHBUTTON_BLUE = exports.DASHBORDER_BLUE = exports.BLUE_LED = exports.BLACK_075 = exports.BLACK_05 = exports.BLACK_025 = exports.BLACK = exports.AQUA_BLUE_05 = exports.AQUA_BLUE_025 = void 0;
const BLACK = exports.BLACK = 'rgb(38,38,38)';
const BLACK_075 = exports.BLACK_075 = 'rgba(38, 38, 38, 0.75)';
const BLACK_05 = exports.BLACK_05 = 'rgba(38, 38, 38, 0.5)';
const BLACK_025 = exports.BLACK_025 = 'rgba(0,0,0, 0.25)';
const GREY = exports.GREY = 'rgba(81, 81, 81, 0.5)';
const GREY_2 = exports.GREY_2 = '#f5f5f5';
const GREY_3 = exports.GREY_3 = 'rgb(143, 142, 148)';
const GREY_4 = exports.GREY_4 = 'rgb(223, 223, 223)';
const HINT_GREY = exports.HINT_GREY = 'rgba(125,125,125, 0.5)';
const MAIN_BLUE = exports.MAIN_BLUE = 'rgb(55, 171, 200)';
const AQUA_BLUE_025 = exports.AQUA_BLUE_025 = 'rgba(55, 171, 200, 0.25)';
const AQUA_BLUE_05 = exports.AQUA_BLUE_05 = 'rgba(55, 171, 200, 0.5)';
const PALE_BLUE = exports.PALE_BLUE = '#94cddc';
const WHITE = exports.WHITE = 'rgb(245,245,245)';
const TRUE_WHITE = exports.TRUE_WHITE = 'rgb(255, 255, 255)';
const PALE_WHITE = exports.PALE_WHITE = 'rgba(245,245,245, 0.5)';
const GREEN = exports.GREEN = 'rgb(0, 213, 146)';
const RED = exports.RED = 'rgb(237, 82, 82)';
const SAND_YELLOW = exports.SAND_YELLOW = 'rgb(244, 218,97)';
const SAND_YELLOW_25 = exports.SAND_YELLOW_25 = 'rgba(244, 218,97, 0.25)';
const SAND_YELLOW_50 = exports.SAND_YELLOW_50 = 'rgba(244, 218, 97, 0.5)';
const BLUE_LED = exports.BLUE_LED = 'rgba(0, 0, 128, 0.5)';
const GREEN_LED = exports.GREEN_LED = 'rgba(0, 128, 0, 0.5)';
const PINK_LED = exports.PINK_LED = 'rgba(128, 0, 128, 0.5)';
const DASHBUTTON_BLUE = exports.DASHBUTTON_BLUE = 'rgb(198,234,239)';
const DASHBORDER_BLUE = exports.DASHBORDER_BLUE = 'rgb(175,221,233)';
const INDICATOR_GREEN = exports.INDICATOR_GREEN = 'rgb(11, 158, 46)';
const INDICATOR_ORANGE = exports.INDICATOR_ORANGE = 'rgb(253, 180, 1)';
const INDICATOR_RED = exports.INDICATOR_RED = 'rgb(237, 82, 82)';
const INDICATOR_WHITE = exports.INDICATOR_WHITE = 'rgba(245,245,245, 0.5)';

//Changed the lightness value in HSL colour picker to get new lighter RGB values
const SCREENFREE_PURPLE = exports.SCREENFREE_PURPLE = 'rgb(118, 53, 151)';
const SCREENFREE_GREEN = exports.SCREENFREE_GREEN = 'rgb(3, 125, 60)';
const SCREENFREE_YELLOW = exports.SCREENFREE_YELLOW = 'rgb(250, 217, 5)';
const SCREENFREE_RED = exports.SCREENFREE_RED = 'rgb(91, 20, 19)';
const SCREENFREE_BLUE = exports.SCREENFREE_BLUE = 'rgb(0, 170, 255)';

//Original RB values for the screenfree cards
// export const SCREENFREE_PURPLE = 'rgb(47, 21, 60)';
// export const SCREENFREE_GREEN  = 'rgb( 1, 55, 26)';
// export const SCREENFREE_YELLOW = 'rgb(97, 85,  2)';
// export const SCREENFREE_RED    = 'rgb(91, 20, 19)';
// export const SCREENFREE_BLUE   = 'rgb( 0, 57, 85)';